import { Link } from "react-router";
import { CSSProperties } from "react";
import "./Footer.scss";

type FooterProps = {
    style?: CSSProperties;
};

const Footer = ({ style }: FooterProps) => {
    const scrollOnTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
        });
    };
    return (
        <div className="footer" style={style}>
            <main className="main-content">
                {/* <section className="logo-year">
                    © 2026 <br /> CYBERSHTAB
                </section> */}
                <section className="logo-year">
                    <div className="logo">
                        <img src='/logo_footer.svg' />
                        <p>2023 - 2026</p>
                    </div>
                    <p className="copyright">©</p>
                </section>
                <section>
                    <h3>НАВИГАЦИЯ</h3>
                    <Link to="/promo" onClick={scrollOnTop}>
                        ПОДРОБНЕЕ О СИСТЕМЕ
                    </Link>
                    <Link to="/feedback" onClick={scrollOnTop}>
                        ОБРАТНАЯ СВЯЗЬ
                    </Link>
                </section>
                <section>
                    <h3>ССЫЛКИ</h3>
                    <a
                        href="https://e.mail.ru/compose/?to=cybershtabru@yandex.ru"
                        target="_blank"
                        rel="noreferrer"
                    >
                        ПОЧТА
                    </a>
                    <a
                        href="https://vk.com/ruscybershtab"
                        target="_blank"
                        rel="noreferrer"
                    >
                        ВКОНТАКТЕ
                    </a>
                </section>
                <section className="helpers">
                    <h3>ПРИ ПОДДЕРЖКЕ</h3>
                    <div className="image-with">
                        <a
                            href="https://www.fasie.ru/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            ФСИ
                        </a>
                        <a
                            href="https://www.fasie.ru/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src={`${process.env.PUBLIC_URL}/Footer/fci-logo.png`}
                                alt="fci-icon"
                                loading="lazy"
                                draggable="false"
                            />
                        </a>
                    </div>
                    <a href="https://guap.ru/" target="_blank" rel="noreferrer">
                        ГУАП
                    </a>
                    <a
                        href="https://sf-petersburg.ru/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        ФЕДЕРАЦИЯ СТРАЙКБОЛА СПБ
                    </a>
                    <a
                        href="https://dosaaf.online/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        ДОСААФ РОССИИ СПБ И ЛО
                    </a>
                </section>
            </main>
            <footer className="bottom-content">
                <p className="ooo-cybershtab">ООО "КИБЕРШТАБ"</p>
                <p>ИНН: 7842226121 ОГРН: 1247800115419</p>
                <p className="all-rights-saved">
                    2023-2026. ВСЕ ПРАВА ЗАЩИЩЕНЫ
                </p>
            </footer>
        </div>
    );
};
export default Footer;